import { create } from 'zustand';

import { VIEW_MODE } from '@/components/app/archive/helpers/hooks/type';

interface ViewModeStore {
  viewMode: VIEW_MODE;
  setViewMode: (viewMode: VIEW_MODE) => void;
}

export const useViewModeStore = create<ViewModeStore>((set) => ({
  viewMode: VIEW_MODE.GRID,
  setViewMode: (viewMode: VIEW_MODE) => set({ viewMode }),
}));
